import { render, staticRenderFns } from "./ComponentSearch.vue?vue&type=template&id=5a65fc1d&"
import script from "./ComponentSearch.vue?vue&type=script&lang=js&"
export * from "./ComponentSearch.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports